export default "/directory/static/discount_seasons.cd12ce6c.svg";